// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd3a5bb3","453":"41b18cf0","455":"f32bdbdf"}[chunkId] + ".chunk.js";
};